import React, { Component } from 'react';
import { Page, Layout, Card, FormLayout, TextField, Banner, SettingToggle, Text, Checkbox, Select, PageActions, TextContainer, Tooltip, InlineStack, Icon, LegacyStack  } from '@shopify/polaris';
import { InfoMinor } from '@shopify/polaris-icons';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { fetchApi } from './helpers/fetchApi';
import { isBannerDismissed, dismissBanner } from './helpers/bannerSession';
import { GlobalPlanBanners } from './GlobalPlanBanners';

export class QuickBuyButton extends Component {

    constructor(props, ref) {
        super(props);
        props.setIsLoading(true);

        this.saveChanges = this.saveChanges.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.togglePreviewActive = this.togglePreviewActive.bind(this);

        this.state = { initState: {}, model: {}, loading: true, previewActive: true, showFreePlanBanner: true };
    }

    componentDidMount() {
        this.populateData();
        this.props.setSaveChanges(this.saveChanges);
        this.props.setDiscardChanges(this.discardChanges);
    }

    discardChanges(){
        this.setState({ model: Object.assign({}, this.state.initState) ,initState: Object.assign({}, this.state.initState) });
    }

    handleChange(fieldName, newValue) {
        window?.shopify?.saveBar?.show("satcb-save-bar");

        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            const isDirty = JSON.stringify(this.state.initState) !== JSON.stringify(model);
            this.props.setIsDirty(isDirty);
            if(!isDirty){
                window?.shopify?.saveBar?.hide("satcb-save-bar");
            }
            return { model };
        });
    }

    togglePreviewActive() {
        this.setState({ previewActive: !this.state.previewActive });
    }

    render() {

        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title="Quick buy button">
                    <Layout>
                        <Layout.Section>
                            <GlobalPlanBanners common={this.props.common} url={window.location.search} />
                        </Layout.Section>
                        <Layout.Section>
                            <Card>
                                <Card.Section>
                                    <LegacyStack alignment="leading" spacing="tight">
                                    <LegacyStack.Item>
                                        <Icon source={InfoMinor} />
                                    </LegacyStack.Item>

                                    <LegacyStack.Item>
                                        <Text as="h3" variant="headingSm">
                                        What is Quick buy button?
                                        </Text>
                                    </LegacyStack.Item>

                                    <LegacyStack.Item fill>
                                        <div style={{ marginTop: 4 }}>
                                        <Text as="p" variant="bodyMd">
                                            Quick Buy button on product listings allows customers to add products
                                            directly from collection pages, homepage, and other listing pages.
                                            With the built in quantity selector, customers can choose how many
                                            items they want and add them to cart instantly without opening the
                                            product page.
                                        </Text>
                                        </div>
                                    </LegacyStack.Item>
                                    </LegacyStack>
                                </Card.Section>
                            </Card>
                            {/* <Banner
                                title="What is Quick buy button?"
                                status="info"
                            >
                                <p>Quick buy button on product listings allows your customers to add products from any page. And with new Quantity selector they can add as much products as they like, right there from the collection page, homepage etc...</p>
                            </Banner> */}
                        </Layout.Section>
                        <Layout.Section>
                            <div id="preview" className={this.state.previewActive ? '' : 'preview-hidden'}>
                                <Card title="Preview" sectioned actions={[{ content: this.state.previewActive ? 'Collapse ↑' : 'Expand ↓', onAction: this.togglePreviewActive }]}>
                                    <div id="satcb_quick_buy_preview" style={{ display: this.state.previewActive ? 'block' : 'none' }}>
                                        <div className="satcb_quick_buy" style={{
                                            left: this.state.model.position === 'top_right' || this.state.model.position === 'bottom_right' ? 'auto' : (this.state.model.showQuantitySelector ? '54px' : '4px'),
                                            right: this.state.model.position === 'top_right' || this.state.model.position === 'bottom_right' ? '4px' : 'auto',
                                            top: this.state.model.position === 'top_right' || this.state.model.position === 'top_left' ? '4px' : 'auto',
                                            bottom: this.state.model.position === 'bottom_right' || this.state.model.position === 'bottom_left' ? '40px' : 'auto',
                                            backgroundColor: this.state.model.backgroundColor,
                                            display: this.state.model.buttonStyle === 'icon_button' ? 'block' : 'none'
                                        }}>
                                            <div>
                                                {this.state.model.cartIcon ?
                                                    <span className="satcb_glyphicon" style={{ color: this.state.model.iconColor }}><img id="satcb_quick_buy_cart_icon" src={this.state.model.cartIcon} width='20' height='20' alt='SATCB Quick buy button icon' /></span>
                                                    : <span className="satcb_glyphicon satcb_glyphicon-shopping-cart" style={{ color: this.state.model.iconColor }}></span>}
                                            </div>
                                        </div>
                                        <input type="number" className="satcb_qb_quantity" defaultValue="1" min="1" style={{
                                            left: this.state.model.position === 'top_right' || this.state.model.position === 'bottom_right' ? 'auto' : '4px',
                                            right: this.state.model.position === 'top_right' || this.state.model.position === 'bottom_right' ? '4px' : 'auto',
                                            top: this.state.model.position === 'top_right' || this.state.model.position === 'top_left' ? '4px' : 'auto',
                                            bottom: this.state.model.position === 'bottom_right' || this.state.model.position === 'bottom_left' ? '40px' : 'auto',
                                            borderColor: this.state.model.backgroundColor,
                                            display: this.state.model.showQuantitySelector && this.state.model.buttonStyle === 'icon_button' ? 'block' : 'none'
                                        }} />
                                    </div>
                                    <div className="satcb_quick_buy_tb" style={{ textAlign: this.state.model.positionTB === 'auto' ? 'center' : this.state.model.positionTB, display: this.state.previewActive && this.state.model.buttonStyle !== 'icon_button' ? 'block' : 'none' }}>
                                        <span className="satcb_quick_buy-action" style={{ color: this.state.model.iconColor, backgroundColor: this.state.model.backgroundColor }}>{this.state.model.postAction !== 'checkout' ? this.state.model.addToCart_Translation : this.state.model.buyNow_Translation}</span>
                                    </div>
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.AnnotatedSection
                            title="Quick buy button state"
                        >
                            <SettingToggle action={{
                                content: this.state.model.enabled ? 'Disable' : 'Enable',
                                onAction: () => { this.handleChange('enabled', !this.state.model.enabled) }
                            }}
                                enabled={this.state.model.enabled}
                            >
                                Quick buy button is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.
                            </SettingToggle>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="Settings">
                            <Card sectioned>
                                <FormLayout>
                                    <Select
                                        label="Button style"
                                        options={[{ label: 'Icon Button', value: 'icon_button' }, { label: 'Text Button', value: 'text_button' }]}
                                        onChange={(newValue) => this.handleChange('buttonStyle', newValue)}
                                        value={this.state.model.buttonStyle}
                                    />
                                    <Checkbox
                                        label="Show on tablets and mobile devices"
                                        checked={this.state.model.showOnMobile}
                                        onChange={(newValue) => this.handleChange('showOnMobile', newValue)}
                                    />
                                    <Checkbox
                                        label="Show on desktop computers"
                                        checked={this.state.model.showOnDesktop}
                                        onChange={(newValue) => this.handleChange('showOnDesktop', newValue)}
                                    />
                                    {
                                        this.state.model.buttonStyle === 'icon_button' ?
                                            <Checkbox
                                                label="Show quantity selector"
                                                checked={this.state.model.showQuantitySelector}
                                                onChange={(newValue) => this.handleChange('showQuantitySelector', newValue)}
                                            />
                                            : ''
                                    }
                                    <Checkbox
                                        label="Show price in variant selector"
                                        checked={this.state.model.showPrice}
                                        onChange={(newValue) => this.handleChange('showPrice', newValue)}
                                    />
                                    {
                                        this.state.model.buttonStyle === 'icon_button' ?
                                            <Select
                                                label="Position"
                                                options={[{ label: 'Top Right', value: 'top_right' }, { label: 'Bottom Right', value: 'bottom_right' }, { label: 'Top Left', value: 'top_left' }, { label: 'Bottom Left', value: 'bottom_left' }]}
                                                onChange={(newValue) => this.handleChange('position', newValue)}
                                                value={this.state.model.position}
                                            />
                                            :
                                            <Select
                                                label="Position"
                                                options={[{ label: 'Auto', value: 'auto' }, { label: 'Left', value: 'left' }, { label: 'Center', value: 'center' }, { label: 'Right', value: 'right' }]}
                                                onChange={(newValue) => this.handleChange('positionTB', newValue)}
                                                value={this.state.model.positionTB}
                                            />
                                    }
                                    <Select
                                        label="When Quick buy button is clicked, add product to cart and"
                                        options={[{ label: 'Stay on current page (Ajaxified)', value: 'no-redirect' }, { label: 'Go To Cart', value: 'cart' }, { label: 'Go To Product Page', value: 'product' }, { label: 'Go To Checkout', value: 'checkout' }]}
                                        onChange={(newValue) => this.handleChange('postAction', newValue)}
                                        value={this.state.model.postAction}
                                    />
                                    <FormLayout.Group>
                                        <ColorPickerCustom
                                            label="Background color"
                                            fieldName="backgroundColor"
                                            value={this.state.model.backgroundColor}
                                            handleChange={this.handleChange}
                                        />
                                        <ColorPickerCustom
                                            label={this.state.model.buttonStyle === 'icon_button' ? 'Icon color' : 'Text color'}
                                            fieldName="iconColor"
                                            value={this.state.model.iconColor}
                                            handleChange={this.handleChange}
                                        />
                                    </FormLayout.Group>

                                    <FormLayout.Group>
                                        <label> Cart icon (20x20) <small><b></b></small> <br />
                                            <input id="cartIcon" type="file" className="Polaris-Button" accept="image/*" onClick={() => document.querySelector('#cartIcon').value = ""}  onChange={() => {
                                                setTimeout(async () => {

                                                    const toBase64 = file => new Promise((resolve, reject) => {
                                                        const reader = new FileReader();
                                                        reader.readAsDataURL(file);
                                                        reader.onload = () => {
                                                            if (file.size > 4096) {
                                                                alert('Cart icon file size should not be greater than 4kb');
                                                                resolve("");
                                                                return;
                                                            }
                                                            resolve(reader.result);
                                                        }
                                                        reader.onerror = error => reject(error);
                                                    });
                                                    
                                                    if (document.querySelector('#cartIcon').files.length > 0) {
                                                        const file = document.querySelector('#cartIcon').files[0];
                                                        var cartIconBase64 = await toBase64(file);
                                                        this.setState(prevState => {
                                                            let model = Object.assign({}, prevState.model);
                                                            model.cartIcon = cartIconBase64;
                                                            return { model };
                                                        });
                                                    }  else {
                                                        this.setState(prevState => {
                                                            let model = Object.assign({}, prevState.model);
                                                            model.cartIcon = "";
                                                            return { model };
                                                        });
                                                    }
                                                }, 500);
                                            }} />
                                        </label>
                                        <span>
                                            <br />
                                            <button className="Polaris-Button" onClick={() => {
                                                this.setState(prevState => {
                                                    let model = Object.assign({}, prevState.model);  // creating copy of state variable jasper
                                                    model.cartIcon = '';                     // update the name property, assign a new value
                                                    return { model };                                 // return new object jasper object
                                                })
                                            }} >Reset cart icon</button>
                                        </span>
                                    </FormLayout.Group>

                                    <LegacyStack vertical spacing="tight">
                                        <LegacyStack wrap={false} alignment="center" spacing="tight">
                                            <Checkbox
                                            label="Enable tracking"
                                            checked={this.state.model.trackingEnabled}
                                            onChange={(newValue) => this.handleChange('trackingEnabled', newValue)}

                                            />
                                            <Tooltip content="This attribute can be used for app auditing and will appear in your Shopify order details page. The attribute name is _Added with Sticky Add To Cart BOOSTER PRO's Quick buy button. This is not visible to your customers.">
                                            <div style={{ lineHeight: 'normal', marginLeft: '4px' }}>
                                                <Icon source={InfoMinor} color="inkLightest" />
                                            </div>
                                            </Tooltip>
                                        </LegacyStack>
                                    </LegacyStack>
                                    <TextField
                                        value={this.state.model.disableUrls}
                                          onChange={(newValue) => this.handleChange('disableUrls', newValue)}
                                          label="Disabling Quick buy button by product URLs"
                                          helpText="To disable Quick buy button on a product, add a link to it, for example, https://yourstore.myshopify.com/products/awesome-product. Place each product URL in a new line."
                                          multiline
                                    />
                                    {
                                        this.state.model.buttonStyle === 'icon_button' ? '' :
                                            <TextContainer>
                                                <Banner title="Disabling Quick buy button by Tag">
                                                    <p>To disable Quick buy button on a product, add <b>Quick buy button disabled</b> tag to it.</p>
                                                </Banner>
                                            </TextContainer>
                                    }
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="Translations">
                            <Card sectioned>
                                <FormLayout>
                                    {
                                        this.state.model.buttonStyle === 'icon_button' ? '' :
                                            <FormLayout.Group>
                                                {
                                                    this.state.model.postAction !== 'checkout' ?
                                                        <TextField
                                                            value={this.state.model.addToCart_Translation}
                                                            onChange={(newValue) => this.handleChange('addToCart_Translation', newValue)}
                                                            label="Add to cart"
                                                        />
                                                        :
                                                        <TextField
                                                            value={this.state.model.buyNow_Translation}
                                                            onChange={(newValue) => this.handleChange('buyNow_Translation', newValue)}
                                                            label="But now"
                                                        />
                                                }
                                                <TextField
                                                    value={this.state.model.soldOut_Translation}
                                                    onChange={(newValue) => this.handleChange('soldOut_Translation', newValue)}
                                                    label="Sold out"
                                                />
                                            </FormLayout.Group>
                                    }
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.addedToCartMessage_Translation}
                                            onChange={(newValue) => this.handleChange('addedToCartMessage_Translation', newValue)}
                                            label="Added to cart message"
                                        />
                                        <div></div>
                                    </FormLayout.Group>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.Section>
                            {/*{window.innerWidth < 768 ? */}
                            {/*<LegacyStack alignment="center" distribution="center">*/}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*</LegacyStack>    */}
                            {/*: */}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*}*/}
                        </Layout.Section>
                        <Layout.Section></Layout.Section>
                        <Layout.Section></Layout.Section>
                        <Layout.Section></Layout.Section>
                        <Layout.Section></Layout.Section>
                    </Layout>
                </Page >
        );
    }

    async populateData() {
        const response = await fetchApi('api/home/quickBuyButton');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.props.setIsLoading(false);
            this.setState({ initState: data, model: data, loading: false });

            var topNavTimer = setInterval(function () {
                if (window?.$('#preview')?.length > 0 && typeof window.$.fn.sticky === 'function') {
                    window?.$('#preview')?.sticky({ topSpacing: 0, zIndex: 100 });
                    clearInterval(topNavTimer); // ← stop after init

                    // keep updating separately
                    setInterval(function () {
                        window?.$('#preview')?.sticky('update');
                    }, 100);
                }
            }, 100);
        }
    }
    
    async saveChanges() {
        
        this.props.setIsLoading(true);
        const response = await fetchApi('api/home/saveQuickBuyButton', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.model) });
        const data = await response.json();
        this.props.setIsLoading(false);

        if (response.ok === true) {
            window?.shopify?.saveBar?.hide("satcb-save-bar");

            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: Object.assign({}, this.state.model) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }
}